import {
  getFromSessionStorage,
  removeFromSessionStorage,
  saveToSessionStorage,
} from "@/utils/localstorage";
import http from "@/utils/axios.js";
import { pick, forEach, set } from "lodash";
import moment from "moment";

const initOrderForData = {
  first_name: "",
  last_name: "",
  email: "",
  gender: "",
  birth_date: "",
  national_number: "",
  country: "GB",
  country_code: "",
  phone_is_valid: false,
};

const initAddressData = {
  id: null,
  city: "",
  home_number: "",
  premises_number: "",
  street: "",
  zip_code: "",
  additional_comments: "",
  additonal_comments: "",
  gate_code: "",
  level: "",
  is_available_home_service: false,
  is_checked_home_service: false,
};

const initInvoiceData = {
  id: null,
  individual: true,
  company_name: "",
  first_name: "",
  last_name: "",
  nip: "",
  street: "",
  home_number: "",
  premises_number: "",
  zip_code: "",
  city: "",
  additonal_comments: "",
};

export default {
  namespaced: true,
  state: {
    patients: getFromSessionStorage("patients_data", []),
    tmpPatients: [],
    selectedPatient: null,
    address: getFromSessionStorage("address", initAddressData),
    selectedAddressId: getFromSessionStorage("selectedAddressId", null),
    wantInvoice: getFromSessionStorage("want_invoice", false),
    invoiceData: getFromSessionStorage("invoice_data", initInvoiceData),
    orderFor: getFromSessionStorage("orderFor", "myself"),
    orderForPatient: getFromSessionStorage("orderForPatient", initOrderForData),
    errors: {},
    isValidTerms: false,
    isTermsAccepted: false,
    orderData: null,
    deliveryAddress: { ...initAddressData },
  },
  getters: {
    getDeliveryAddress: (state) => state.deliveryAddress,
    getOrderData: (state) => state.orderData,
    getOrderFor: (state) => state.orderFor,
    getPatients: (state) => state.patients,
    getPatientByPhone: (state) => (phoneNumber) => {
      return state.patients.find(
        (patient) => patient.phone_number == phoneNumber
      );
    },
    getPatientsIds: (state) => state.patients.map((patient) => patient.id),
    getTmpPatients: (state) => state.tmpPatients,
    getTmpPatientsIds: (state) =>
      state.tmpPatients.map((patient) => patient.id),
    getSelectedPatient: (state) => state.selectedPatient,
    getAddressData: (state) => state.address,
    getSelectedAddressId: (state) => state.selectedAddressId,
    getPersonalData: (state) => state.orderForPatient,
    getWantInvoice: (state) => state.wantInvoice,
    getInvoiceData: (state) => state.invoiceData,
    getErrors: (state) => state.errors,
    isTermsAccepted: (state) => state.isTermsAccepted,
  },
  mutations: {
    setErrors(store, errors) {
      store.errors = { ...errors };
    },
    clearErrors(store) {
      store.errors = {};
    },
    setSelectedPatient(store, patient) {
      store.selectedPatient = { ...patient };
    },
    setUpTmpPatients(store) {
      store.tmpPatients = [...store.patients];
    },
    setTmpPatients(store, tmpPatients) {
      store.tmpPatients = [...tmpPatients];
    },
    pushTmpPatient(store, payload) {
      store.tmpPatients.push({ ...payload });
    },
    updateTmpPatient(store, { id, patient }) {
      const index = store.tmpPatients.findIndex((patient) => patient.id === id);
      store.tmpPatients[index] = { ...patient };
    },
    savePatient(store, patient) {
      store.patients = [...store.patients, patient];
      saveToSessionStorage("patients_data", store.patients);
    },
    updatePatient(store, { id, patient }) {
      const index = store.patients.findIndex((patient) => patient.id === id);
      store.patients[index] = { ...store.patients[index], ...patient };
      saveToSessionStorage("patients_data", store.patients);
    },
    deletePatient(store, patientId) {
      const index = store.patients.findIndex(
        (patient) => patient.id === patientId
      );
      store.patients.splice(index, 1);
      saveToSessionStorage("patients_data", store.patients);
    },
    deleteTmpPatient(store, patientId) {
      const index = store.tmpPatients.findIndex(
        (patient) => patient.id === patientId
      );
      store.tmpPatients.splice(index, 1);
    },
    clearTmpPatients(store, age = null) {
      if (age) {
        store.tmpPatients = store.tmpPatients.filter(
          (patient) => patient.age != age
        );
      } else {
        store.tmpPatients = [];
      }
    },
    saveTmpPatients(store) {
      store.patients = [...store.patients, ...store.tmpPatients];
      store.tmpPatients = [];
      saveToSessionStorage("patients_data", store.patients);
    },
    setAddressData(store, payload) {
      store.address = { ...store.address, ...payload };
      saveToSessionStorage("address", store.address);
    },
    setDeliveryAddress(store, payload) {
      store.deliveryAddress = { ...store.deliveryAddress, ...payload };
    },
    setSelectedAddressId(store, payload) {
      store.selectedAddressId = payload;
      saveToSessionStorage("selectedAddressId", store.selectedAddressId);
    },
    setOrderData(store, payload) {
      store.orderData = payload;
    },
    setPersonalData(store, payload) {
      store.orderForPatient = { ...store.orderForPatient, ...payload };
      saveToSessionStorage("orderForPatient", store.orderForPatient);
    },
    setOrderFor(store, payload) {
      store.orderFor = payload;
      saveToSessionStorage("orderFor", store.orderFor);
    },
    setWantInvoice(store, state) {
      store.wantInvoice = state;
    },
    setInvoiceData(store, data) {
      store.invoiceData = { ...store.invoiceData, ...data };
    },
    setInvoiceDataValue(store, { key, value }) {
      store.invoiceData[key] = value;
    },
    setZoneId(store, zone_id) {
      store.address = { ...store.address, zone_id };
      saveToSessionStorage("address", store.address);
    },
    setTermsAccepted(store, state) {
      store.isTermsAccepted = state;
    },
    clearData(store) {
      store.wantInvoice = false;
      store.invoiceData = { ...initInvoiceData };

      removeFromSessionStorage("want_invoice");
      removeFromSessionStorage("invoice_data");
    },
    clearPatients(store) {
      store.patients = [];
      removeFromSessionStorage("patients_data");
    },
    clearPersonalData(store) {
      store.orderForPatient = initOrderForData;
      store.orderFor = "myself";
      store.address = initAddressData;
      store.selectedAddressId = null;
      removeFromSessionStorage("orderForPatient");
      removeFromSessionStorage("address");
      removeFromSessionStorage("selectedAddressId");
      removeFromSessionStorage("orderFor");
    },
  },
  actions: {
    async checkZone({ commit, getters, rootGetters }) {
      const cityZone = rootGetters["cart/getSelectedCityZone"];
      const isHomeService = rootGetters["cart/isHomeService"];
      if (cityZone) {
        commit("setZoneId", cityZone);
      } else if (isHomeService && getters.getAddressData.zip_code != "") {
        try {
          const { data } = await http.get(
            `city/zone/${getters.getAddressData.zip_code}`
          );

          commit("setZoneId", data.zone_id);
        } catch (error) {
          commit("setZoneId", null);
        }
      }
    },
    createOrUpdatePatient({ commit, getters, dispatch }, patient) {
      const storedPatient = getters.getPatientByPhone(patient.national_number);

      let newPatientData = pick(patient, [
        "id",
        "birth_date",
        "country",
        "country_code",
        "first_name",
        "last_name",
      ]);

      newPatientData = {
        ...newPatientData,
        sex: patient.gender ?? "m",
        phone_number: patient.national_number,
        age: "adult",
        birth_date: moment(patient.birth_date, "DD.MM.YYYY").format(
          "YYYY-MM-DD"
        ),
      };

      if (storedPatient) {
        const oldPatientId = storedPatient.id;
        commit("updatePatient", {
          id: oldPatientId,
          patient: newPatientData,
        });

        dispatch(
          "cart/reAssignExamination",
          { oldPatientId, newPatientId: patient.id },
          { root: true }
        );
        dispatch(
          "cart/reAssignVisitServices",
          { oldPatientId, newPatientId: patient.id },
          { root: true }
        );
      } else {
        commit("savePatient", {
          id: patient.id,
          ...newPatientData,
        });

        if (getters.getPatients.length === 1) {
          dispatch("cart/assignCartToPatients", [patient.id], {
            root: true,
          });
          dispatch("cart/assignVisitServicesToPatients", [patient.id], {
            root: true,
          });
        }
      }
    },
    updatePatientById({ commit }, { id, patient }) {
      let newPatientData = pick(patient, [
        "birth_date",
        "country",
        "country_code",
        "first_name",
        "last_name",
        "pesel",
      ]);

      newPatientData = {
        ...newPatientData,
        isNoPesel: patient.pesel ? false : true,
        sex: patient.gender,
        phone_number: patient.national_number,
        age: "adult",
      };

      commit("updatePatient", { id, patient: newPatientData });
    },
    updateAddressData({ commit }, payload) {
      commit("setAddressData", payload);
    },
    loadDefaultInvoiceData({ commit, rootGetters }) {
      const firstInvoiceData = rootGetters["user/getInvoicesData"][0];
      const user = rootGetters["user/getCurrentUser"];

      if (user && firstInvoiceData) {
        commit("setInvoiceData", {
          first_name: user.first_name,
          last_name: user.last_name,
          ...firstInvoiceData,
        });
      } else if (user) {
        const address = rootGetters["user/getAddress"];

        commit("setInvoiceData", {
          first_name: user.first_name,
          last_name: user.last_name,
        });

        if (address) {
          commit("setInvoiceData", {
            street: address.street,
            home_number: address.home_number,
            premises_number: address.premises_number,
            zip_code: address.zip_code,
            city: address.city,
            additonal_comments: address.additonal_comments,
          });
        }
      }
    },
    loadDefaultInvoicePersonalData({ commit, rootGetters }) {
      const user = rootGetters["user/getCurrentUser"];

      if (user) {
        commit("setInvoiceData", {
          first_name: user.first_name,
          last_name: user.last_name,
        });
      }
    },
    async payForOrder({ state, commit }, orderId) {
      commit("clearErrors");

      return new Promise((resolve, reject) => {
        return http
          .post(`/orders/pay/${orderId}`, {
            isTermsAccepted: state.isTermsAccepted,
            wantInvoice: state.wantInvoice,
            invoiceData: state.invoiceData,
            deliveryAddress: state.deliveryAddress,
          })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            if (response && response.status === 422) {
              const errorArr = {};
              forEach(response.data.errors, (error, key) => {
                set(errorArr, key, error);
              });
              commit("setErrors", errorArr);
              reject(errorArr);
            } else {
              reject(response.data);
            }
          });
      });
    },
    async updateOrder({ state, rootGetters, commit }) {
      commit("clearErrors");
      const isHomeService = rootGetters["cart/isHomeService"];

      return new Promise((resolve, reject) => {
        const data = {
          isHomeService,
          isTermsAccepted: state.isTermsAccepted,
          city_uuid: rootGetters["cart/getSelectedCity"]?.uuid,
          facility_id: rootGetters["cart/getSelectedFacility"]?.id,
          discount: rootGetters["cart/getDiscountCode"],
          ...(isHomeService && { address: state.address }),
          ...(isHomeService && { addressId: state.selectedAddressId }),
          wantInvoice: state.wantInvoice,
          invoiceData: state.invoiceData,
        };

        return http
          .put(`/referralGroups/${state.orderData.id}`, data)
          .then(({ data }) => {
            commit("clearData");
            commit("cart/clearAll", null, { root: true });
            commit("clearPersonalData");
            commit("setOrderData", null);
            resolve(data);
          })
          .catch(({ response }) => {
            if (response && response.status === 422) {
              const errorArr = {};
              forEach(response.data.errors, (error, key) => {
                set(errorArr, key, error);
              });
              commit("setErrors", errorArr);
              reject(errorArr);
            } else if (response && response.status === 401) {
              commit("setErrors", {
                unauthenticated: ["error.auth.required"],
              });
              reject(response.data);
            } else {
              reject(response.data);
            }
          });
      });
    },
    async makeOrder({ state, rootGetters, commit }) {
      commit("clearErrors");
      const isHomeService = rootGetters["cart/isHomeService"];

      return new Promise((resolve, reject) => {
        const data = {
          isHomeService,
          orderFor: state.orderFor,
          isTermsAccepted: state.isTermsAccepted,
          city_uuid: rootGetters["cart/getSelectedCity"]?.uuid,
          facility_id: rootGetters["cart/getSelectedFacility"]?.id,
          examinations: rootGetters["cart/getCartIds"],
          visitServices: rootGetters["cart/getVisitServicesIds"],
          nursingService: {
            price:
              rootGetters["examinations/getNursingServices"]?.nursing_service
                ?.price,
            quantity: rootGetters["cart/getAdditionalServices"]?.quantity,
          },
          discount: rootGetters["cart/getDiscountCode"],
          ...(isHomeService && { address: state.address }),
          ...(isHomeService && { addressId: state.selectedAddressId }),
          ...(state.orderFor === "someone_else" && {
            orderForPatient: state.orderForPatient,
          }),
          wantInvoice: state.wantInvoice,
          invoiceData: state.invoiceData,
        };

        return http
          .post("/orders", data)
          .then(({ data }) => {
            commit("clearData");
            commit("cart/clearAll", null, { root: true });
            commit("clearPersonalData");
            resolve(data);
          })
          .catch(({ response }) => {
            if (response && response.status === 422) {
              const errorArr = {};
              forEach(response.data.errors, (error, key) => {
                set(errorArr, key, error);
              });
              commit("setErrors", errorArr);
              reject(errorArr);
            } else if (response && response.status === 401) {
              commit("setErrors", {
                unauthenticated: ["error.auth.required"],
              });
              reject(response.data);
            } else {
              reject(response.data);
            }
          });
      });
    },
  },
};
